import { call, put } from 'redux-saga/effects';
import { alertPush, sendError } from '../../../';
import { forgotPasswordError, ForgotPasswordFetch, forgotPasswordSuccess } from '../actions';
import { appUrls } from '../../../../api-new/urls';
import api from '../../../../api-new/http';

export function* forgotPasswordSaga(action: ForgotPasswordFetch) {
    try {
        yield call(() => api.post(`${appUrls.authenURL}/forgot-password`, action.payload));
        yield put(forgotPasswordSuccess());
        yield put(
            alertPush({
                message: [
                    '📩 Password Reset Email Sent',
                    'Please check your inbox and follow the instructions to reset your password. If you don’t see the email, check your spam folder.',
                ],
                type: 'success',
            }),
        );
    } catch (error: any) {
        const errorSetup = {
            message: error.response.data.errors[0].errorMessage,
            code: error.response.status,
            codeConfig: error.response.data.errors[0].errorCode,
        };
        yield put(
            sendError({
                error: errorSetup,
                processingType: 'alert',
                extraOptions: {
                    actionError: forgotPasswordError,
                },
            }),
        );
    }
}
